import { FormLabel } from '../../../../primitives/index.js'
import { capitalize } from '@tunasong/models'
import type { FieldValues } from 'react-hook-form'
import type { FormField, ObjectFormField } from '../../../lib/form-field.js'
import type { FormComponentGroupComponentProps } from '../form-component.js'
import FormControl from '../form-control.js'
import styles from '../form-box.module.css'

export interface ObjectSchemaFieldProps<S extends FieldValues>
  extends FormComponentGroupComponentProps<ObjectFormField, S> {}

export function ObjectSchemaField<S extends FieldValues>(props: ObjectSchemaFieldProps<S>) {
  const { name: objectName, spec, register, control, errors, ...restProps } = props
  const label = capitalize(spec.metadata?.label ?? objectName)

  return (
    <div className={styles.formBox}>
      <FormLabel className={styles.formLabel}>{label}</FormLabel>
      {Object.entries(spec.childForm).map((e, idx) => {
        const [name, formEl] = e as [string, FormField]
        const fieldName = objectName ? `${objectName}.${name}` : name
        return (
          <FormControl
            key={name}
            autoFocus={idx === 0}
            name={fieldName}
            formField={formEl}
            errors={errors}
            // @todo fix this type assertion
            register={register as never}
            control={control as never}
            {...restProps}
          />
        )
      })}
    </div>
  )
}

export default ObjectSchemaField
